import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { useStyles } from './styles';
const ButtonGithub = ({ githubUrl }) => {
    const ownClasses = useStyles();
    return (React.createElement("a", { href: githubUrl, className: ownClasses.root, target: "_blank", rel: "noreferrer" },
        React.createElement(Icon, { icon: ['fab', 'github'] })));
};
export default ButtonGithub;
